import script from "./OrderHistoryCrowdfunding.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderHistoryCrowdfunding.vue?vue&type=script&setup=true&lang=js"

import "./OrderHistoryCrowdfunding.vue?vue&type=style&index=0&id=dd89dcd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd89dcd0"]])

export default __exports__